import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=efe1edf2&scoped=true"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe1edf2",
  null
  
)

export default component.exports